import { useAppContext } from '@/context';
import { logout } from '@/utils/auth';
import { postJson } from '@/utils/fetchOptions';

// eslint-disable-next-line import/no-cycle
import { useAuthToken, useMutation } from '.';

interface UseTeamMemberInviteProps {
  onSuccess: TypeAny;
  teamId: string;
  email: string;
  role: string;
  name: string;
}

export function useTeamMemberInvite({
  onSuccess,
  teamId,
  email,
  role,
  name
}: UseTeamMemberInviteProps) {
  const { setAlert } = useAppContext();
  const token = useAuthToken();

  const {
    mutate: mutation,
    isLoading,
    error
  } = useMutation({
    mutationKey: 'team-member-invite',
    mutationFn: async () =>
      postJson({
        url: `${process.env.NEXT_PUBLIC_BEATLY_API_URL}/app/v2/team/${teamId}/member/invite`,
        body: {
          name,
          email,
          role
        },
        token
      }).then((response: Api.Member | ResponseObject) => {
        if ((response as ResponseExpiredToken).isExpired) {
          logout();
        }

        if ('code' in response) {
          setAlert(response.code);
        }

        return response;
      }),
    onSuccess
  });

  return {
    isLoading,
    mutation,
    error
  };
}
